// extracted by mini-css-extract-plugin
module.exports = {"DiagonalMenuSkin":"_1di6D","diagonalMenuSkin":"_1di6D","itemsContainer":"_2HInr","dropWrapper":"_1LDwx","showMore":"_2DYhX","moreContainer":"hrq82"};